module.exports = __webpack_public_path__ + "img/paisajemyaccountdesktop.9e859680.jpg";